import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useContactsStore } from '../../../store';
import { ContactType } from '../../../domains/common.domain';

interface IProps {
  contactsType: ContactType;
}

export const ContactsReview = observer((props: IProps) => {
  const { t } = useTranslation('', { keyPrefix: 'REVIEW_AND_SIGN_UP' });
  const { t: tCommon } = useTranslation('');
  const { contactsType } = props;
  const { contactsStore } = useContactsStore(contactsType);
  const { contacts, hideEmail, hidePhone } = contactsStore;
  const contactTitle = t(`${contactsType.toUpperCase()}_CONTACT`);

  return (
    <div>
      {contacts.map((x, index) => (
        <div key={index} className="avoid-break">
          {index > 0 ? <hr /> : null}
          <h4>
            <span>{contacts.length > 1 ? `${contactTitle} ${index + 1}` : contactTitle}</span>
          </h4>
          <div className="container-readonly">
            <label>{t('NAME')}</label>
            <span>
              {x.firstName.value} {x.lastName.value}
            </span>
          </div>
          {!hideEmail && (
            <div className="container-readonly">
              <label>{t('EMAIL')}</label>
              <span>{x.email.value}</span>
            </div>
          )}
          {!hidePhone && (
            <div className="container-readonly">
              <label>{tCommon('CONTACT.PHONE_NUMBER')}</label>
              <span>{x.phoneNumber.value}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
});
